import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@mui/styles";
import { Snackbar as MUISnackbar, IconButton } from "@mui/material";
// @material-ui/icons
import Close from '@mui/icons-material/Cancel';
// core components
import styles from "../../assets/jss/psstyle/component/snackbarContentStyle";
import MuiAlert from '@mui/material/Alert';

const useStyles = makeStyles(styles);

export default function CustomSnackbar(props) {
  const classes = useStyles();
  // Destructure all props to prevent them from being passed to DOM elements
  const { message, color, close, icon, place, open, closeNotification, autoClose, ...rest } = props;
  
  var action = [];
  const messageClasses = classNames({
    [classes.iconMessage]: icon !== undefined
  });

  const Alert = React.forwardRef(function Alert(alertProps, ref) {
    // Only pass valid MUI Alert props, not custom props
    const { onClose, severity, sx, children } = alertProps;
    return <MuiAlert elevation={6} ref={ref} variant="filled" onClose={onClose} severity={severity} sx={sx}>{children}</MuiAlert>;
  });

  if (close !== undefined && close !== false) {
    action = [
      <IconButton
        className={classes.iconButton}
        key="close"
        aria-label="Close"
        color="inherit"
        onClick={() => closeNotification()}
      >
        <Close className={classes.close} />
      </IconButton>
    ];
  }

  // Build an explicit set of props to pass to MUI Snackbar/Alert so no unknown props reach DOM
  const anchorOrigin = {
    vertical: place && place.indexOf("t") === -1 ? "bottom" : "top",
    horizontal: place && place.indexOf("l") !== -1 ? "left" : place && place.indexOf("c") !== -1 ? "center" : "right",
  };

  return (
    <MUISnackbar
      open={Boolean(open)}
      autoHideDuration={typeof autoClose === 'number' ? autoClose : 3600}
      onClose={() => closeNotification && closeNotification()}
      anchorOrigin={anchorOrigin}
      sx={{
        maxWidth: '90vw',
        width: 'auto',
        '& .MuiSnackbarContent-root': {
          maxWidth: 'none',
          width: 'auto',
          height: 'auto'
        }
      }}
    >
      <Alert
        onClose={() => closeNotification && closeNotification()}
        severity={color}
        sx={{
          width: 'auto',
          maxWidth: '90vw',
          minWidth: '300px',
          height: 'auto',
          minHeight: '48px',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
          overflow: 'visible',
          display: 'flex',
          alignItems: 'center',
          padding: '12px 16px',
          '& .MuiAlert-message': {
            width: '100%',
            height: 'auto',
            overflow: 'visible',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            padding: '0',
            display: 'block',
            lineHeight: '1.5'
          },
          '& .MuiAlert-icon': {
            padding: '0',
            marginRight: '12px',
            alignSelf: 'center'
          },
          '& .MuiAlert-action': {
            padding: '0',
            marginLeft: '12px',
            alignSelf: 'center'
          }
        }}
      >
        {message}
      </Alert>
    </MUISnackbar>
  );
}

CustomSnackbar.propTypes = {
  message: PropTypes.node.isRequired,
  color: PropTypes.oneOf(["info", "success", "warning", "danger", "primary"]),
  close: PropTypes.bool,
  icon: PropTypes.object,
  place: PropTypes.oneOf(["tl", "tr", "tc", "br", "bl", "bc"]),
  open: PropTypes.bool,
  closeNotification: PropTypes.func,
  autoClose: PropTypes.number
};

CustomSnackbar.defaultProps = {
  open: false,
  autoClose: 3600,
  close: false,
  message: "",
  color: "info",
  icon: null,
  place: "br",
}